<script setup lang="ts">
import { DialogRoot, DialogOverlay, DialogContent, DialogTitle } from 'reka-ui'
import WebDirectSidebar from './WebDirectSidebar.vue'

interface IWebDirectSidebarDrawerProps {
  readonly open: boolean
  readonly logoUrl?: string
  readonly fallbackLogoUrl?: string
  readonly name?: string
  readonly isAuthenticated?: boolean
  readonly userName?: string | null
  readonly userDisplayName?: string | null
  readonly appVersion?: string
}

interface IWebDirectSidebarDrawerEmits {
  'update:open': [value: boolean]
  logout: []
}

defineProps<IWebDirectSidebarDrawerProps>()
const emit = defineEmits<IWebDirectSidebarDrawerEmits>()
</script>

<template>
  <DialogRoot :open="open" @update:open="emit('update:open', $event)">
    <DialogOverlay
      class="fixed inset-0 data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0 bg-foreground/50"
      style="z-index: calc(var(--widget-z-index) + 1)"
    />
    <DialogContent
      class="fixed inset-y-0 left-0 outline-none data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left"
      style="z-index: calc(var(--widget-z-index) + 2)"
    >
      <DialogTitle class="sr-only">Navigation</DialogTitle>
      <WebDirectSidebar
        :logo-url="logoUrl"
        :fallback-logo-url="fallbackLogoUrl"
        :name="name"
        :is-authenticated="isAuthenticated"
        :user-name="userName"
        :user-display-name="userDisplayName"
        :app-version="appVersion"
        :closeable="true"
        @close="emit('update:open', false)"
        @logout="emit('logout')"
      />
    </DialogContent>
  </DialogRoot>
</template>
